import { IconProps } from '@hcs/types';

import { useIcon } from '../../../hooks/useIcon';

import Copy from './CopyIcon.svg?react';
import Exclude from './ExcludeIcon.svg?react';
import HeartOutline from './HeartOutlineIcon.svg?react';
import Info from './InfoIcon.svg?react';
import InfoSmall from './InfoSmallIcon.svg?react';
import SavedFilters from './SavedFiltersIcon.svg?react';
import StarFilled from './StarFilledIcon.svg?react';
import Star from './StarIcon.svg?react';
import StarEmpty from './StarIconEmpty.svg?react';
import StarOutline from './StarOutlineIcon.svg?react';
import StreetView from './StreetViewIcon.svg?react';
import Tag from './TagIcon.svg?react';
import UnselectedFilters from './UnselectedFiltersIcon.svg?react';

export const CopyIcon = (props: IconProps) => useIcon(Copy, props);
export const ExcludeIcon = (props: IconProps) => useIcon(Exclude, props);
export const HeartOutlineIcon = (props: IconProps) =>
  useIcon(HeartOutline, props);
export const InfoIcon = (props: IconProps) => useIcon(Info, props);
export const InfoSmallIcon = (props: IconProps) => useIcon(InfoSmall, props);
export const SavedFiltersIcon = (props: IconProps) =>
  useIcon(SavedFilters, props);
export const StarFilledIcon = (props: IconProps) => useIcon(StarFilled, props);
export const StarIcon = (props: IconProps) => useIcon(Star, props);
export const StarIconEmpty = (props: IconProps) => useIcon(StarEmpty, props);
export const StarOutlineIcon = (props: IconProps) =>
  useIcon(StarOutline, props);
export const StreetViewIcon = (props: IconProps) => useIcon(StreetView, props);
export const TagIcon = (props: IconProps) => useIcon(Tag, props);
export const UnselectedFiltersIcon = (props: IconProps) =>
  useIcon(UnselectedFilters, props);
